import { IntlShape } from 'react-intl';

interface Params {
  intl: IntlShape;
  price: number;
  currency: string;
  paymentDate?: number;
  isSubscriptionActive?: boolean;
}

const getPlanChangedNotificationMessage = ({ intl, price, paymentDate, currency, isSubscriptionActive }: Params) => {
  if (paymentDate) {
    const formattedPrice = intl.formatNumber(price, { style: 'currency', currency });

    if (isSubscriptionActive) {
      return intl.formatMessage({
        id: 'pricePlans.changePlanModal.changePlanSuccess',
        defaultMessage: 'Plan successfully changed. You will be charged {price} on {paymentDate}.',
      }, {
        price: formattedPrice,
        paymentDate: intl.formatDate(paymentDate! * 1000, { year: 'numeric', month: 'short', day: 'numeric' }),
      });
    }

    return intl.formatMessage({
      id: 'pricePlans.changePlanModal.planChangedWhenSubscriptionInactive',
      defaultMessage: 'Plan changed successfully. You will be charged {price} when your subscription is renewed.',
    }, {
      price: formattedPrice,
    });
  }

  return intl.formatMessage({
    id: 'pricePlans.changePlanModal.planChangedBeforeTrialStarted',
    defaultMessage: 'Plan successfully changed.',
  });
};

export default getPlanChangedNotificationMessage;
